import axios from "axios";
import React, { use, useEffect, useRef, useState } from "react";
import API from "../../Common/API";
import { motion } from "framer-motion";
import profession from "../../Assets/Icons/profession.svg";
import income from "../../Assets/Icons/income.svg";
import date from "../../Assets/Icons/date.svg";
import stars from "../../Assets/Icons/star.svg";
import workLocation from "../../Assets/Icons/workLocation.svg";
import flawsIcon from "../../Assets/Icons/flaws.svg";
import { FaArrowLeft, FaGraduationCap } from "react-icons/fa6";
import { TbZodiacCancer } from "react-icons/tb";
import RasiKattam from "../../Components/RasiKattam";
import AmsaKattam from "../../Components/AmsaKattam";
import PreviewUserLoader from "../../Components/Loaders/PreviewUserLoader";
import { PhotoProvider, PhotoView } from "react-photo-view";
import "react-photo-view/dist/react-photo-view.css";
import { useDispatch, useSelector } from "react-redux";

import { useTranslation } from "react-i18next";
import dummy from "../../Assets/Images/dummy.jpg.webp";
import { useHistory } from "react-router-dom";
import { setAlert } from "../../Store/Theme/actions";
import PrintUser from "./PrintUser";
import Button from "../../Components/Button";
import Dialog from "../../Components/Dialog";
import { RiPassValidFill } from "react-icons/ri";
import FieldInput from "../../Components/FieldInput";
import * as Yup from "yup";
import { useFormik } from "formik";
import { Dropzone, FileMosaic } from "@files-ui/react";

const initialHappyCustomerValues = {
  groomName: "",
  brideName: "",
  weddingDate: "",
  engagementDate: "",
  story: "",
  imageUrl: "",
};

const PreviewUser = ({ registerValues, match }) => {
  const [userDetails, setUserDetails] = useState({});

  const educationList = useSelector((state) => state.auth.educationList);
  const zodiacSigns = useSelector((state) => state.auth.zodiacSigns);
  const flaws = useSelector((state) => state.auth.flaws);

  const allStars = useSelector((state) => state.auth.allStars);
  const status = useSelector((state) => state.auth.status);
  const tStatus = useSelector((state) => state.auth.tStatus);
  const tFlaws = useSelector((state) => state.auth.tFlaws);

  const [loading, setLoading] = useState(true);
  const [downloadConfirm, setDownloadConfirm] = useState(false);
  const dispatch = useDispatch();

  const dhisas = useSelector((state) => state.auth.dhisa);
  const { t } = useTranslation();
  const history = useHistory();
  const [happyDialog, setHappyDialog] = useState(false);
  const [changes, setChanges] = useState([]);
  const [validDetails, setValidDetails] = useState();
  const [happyFormDialog, setHappyFormDialog] = useState(false);
  const [files, setFiles] = React.useState([]);
  const [fileUrls, setFileUrls] = useState([]);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [count, setCount] = useState(0);

  const printRef = useRef();

  useEffect(() => {
    try {
      axios
        .all([
          API.get(`/user/getUserDetailsById/${match.params.id}`),
          API.get(`/plans/getSubscribedPlanDetailsByUserId/${match.params.id}`),
        ])
        .then(
          axios.spread((userRes, subRes) => {
            setValidDetails(subRes.data.data);
            setUserDetails(userRes.data.data);
            if (userRes.data.data.status === 6) {
              API.get(`/user/getChanges/${userRes.data.data._id}`).then(
                (changeRes) => {
                  if (changeRes.status === 200) {
                    setChanges(changeRes.data.data);
                    setLoading(false);
                  }
                }
              );
            } else {
              setLoading(false);
            }
            // setEducationList(eduRes.data.data.map((c) => { return { text: `${c.education} ${c.specialization !== null ? `- ${c.specialization}` : ''}`, value: c._id } }))
            // setFullEducations(eduRes.data.data)
            // setZodiacSigns(zodiacRes.data.data.map((c) => { return { text: `${c.zodiacSign}`, value: c._id } }))
            // setFlaws(flawRes.data.data.map((c) => { return { text: c.flawName, value: c._id } }))
            // setStatus(statRes.data.data.map((c) => { return { text: c.status, value: c._id } }))
            // setOccupation(occuRes.data.data)
            // setAllStars(starRes.data.data.map((c) => { return { text: c.star, value: c._id } }))
          })
        );
    } catch (err) {
      console.log(err);
    }
  }, [count]);

  const calculateAge = (birthdate) => {
    const today = new Date();
    const birthDate = new Date(birthdate);
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();

    // If birth month is after current month or same month but birth date is after current date, subtract 1
    if (
      monthDiff < 0 ||
      (monthDiff === 0 && today.getDate() < birthDate.getDate())
    ) {
      age--;
    }

    return age;
  };

  const getFlaws = (value) => {
    // if (lang === 'en') {
    //     return flaws.filter((x) => x.value === value)[0].text
    // } else {
    //     return tFlaws.filter((x) => x.value === value)[0].text
    // }
    return value
      ? flaws.filter((x) => x.value === value)[0].text ||
          tFlaws.filter((x) => x.value === value)[0].text
      : "-";
  };
  const getStatus = (value) => {
    console.log(value);
    return value
      ? status.filter((x) => x.value === value)[0].text ||
          tStatus.filter((x) => x.value === value)[0].text
      : "-";
  };

  const getZodiac = (value) => {
    return zodiacSigns.filter((x) => {
      return x.value === value;
    })[0].text;
  };

  const getStars = (value) => {
    return allStars.filter((x) => {
      return x.value === value;
    })[0].text;
  };

  const getQualification = (value) => {
    return educationList.filter((x) => {
      return x.value === value;
    })[0].text;
  };

  const downloadProfile = (value) => {
    setDownloadConfirm(true);
  };

  const getDhisas = (values) => {
    if (values) {
      return dhisas.filter((x) => {
        return x.value === parseInt(values);
      })[0].text;
    } else {
      return "-";
    }
  };

  const formatTo12Hour = (time24) => {
    if (!time24) return "";

    const [hour, minute] = time24.split(":").map(Number);
    const period = hour >= 12 ? "PM" : "AM";
    const hour12 = hour % 12 === 0 ? 12 : hour % 12;

    return `${hour12}:${minute.toString().padStart(2, "0")} ${period}`;
  };

  const approveProfile = () => {
    API.get(`/user/approveUser/${userDetails._id}`).then((res) => {
      if (res.status === 200) {
        dispatch(
          setAlert({
            title: "Success",
            subtitle: "Profile Approved Successfully",
            active: true,
            type: "success",
          })
        );
        history.goBack();
      }
    });
  };

  const declineProfile = () => {
    API.get(`/user/declineUser/${userDetails._id}`).then((res) => {
      if (res.status === 200) {
        dispatch(
          setAlert({
            title: "Success",
            subtitle: "Profile Approved Successfully",
            active: true,
            type: "success",
          })
        );
        history.goBack();
      }
    });
  };

  const verifyProfile = () => {
    API.get(`/user/verifyProfile/${userDetails._id}`).then((res) => {
      if (res.status === 200) {
        dispatch(
          setAlert({
            title: "Success",
            subtitle: "Profile verified successfully",
            active: true,
            type: "success",
          })
        );
        history.goBack();
      }
    });
  };

  const pendingProfile = () => {
    API.get(`/user/moveToPending/${userDetails._id}`).then((res) => {
      if (res.status === 200) {
        dispatch(
          setAlert({
            title: "Success",
            subtitle: "Profile moved to pending successfully",
            active: true,
            type: "success",
          })
        );
      }
    });
  };

  const handlePrint = () => {
    window.print();
  };

  const clearHeights = (height) => {
    let input = height;
    let cleaned = input && input?.match(/\d+\s*ft\s*\d*\s*in/);
    return cleaned ? cleaned[0] : "--";
  };

  const makeHappyCustomer = () => {
    setHappyDialog(false);
    setHappyFormDialog(true);
    if (userDetails?.profileType === "bride") {
      happyForm.setFieldValue(
        "brideName",
        `${userDetails?.firstName} ${userDetails?.surname}`
      );
    } else {
      happyForm.setFieldValue(
        "groomName",
        `${userDetails?.firstName} ${userDetails?.surname}`
      );
    }
    // API.get(`/user/makeHappyCustomer`).then((res)=>{
    //     if(res.status === 200){
    //         dispatch(setAlert({title:'Success',subtitle:'Customer status changed',active:true,type:'success'}))
    //         history.goBack()
    //     }
    // })
  };

  const getChangedDateOfBirth = (values) => {
    return (
      values?.split("-")[2] +
      "/" +
      values?.split("-")[1] +
      "/" +
      values?.split("-")[0]
    );
  };

  const happyFormSchema = Yup.object().shape({
    groomName: Yup.string().required("Groom Name is required"),
    brideName: Yup.string().required("Bride Name is required"),
    weddingDate: Yup.string().nullable(),
    engagementDate: Yup.string().nullable(),
    story: Yup.string().nullable(),
    imageUrl: Yup.string().nullable(),
  });

  const happyForm = useFormik({
    initialValues: initialHappyCustomerValues,
    validateOnMount: true,
    enableReinitialize: true,
    validationSchema: happyFormSchema,
    onSubmit: (values) => {
      const updatedImages = [...files];
      const formData = new FormData();
      formData.append("userId", JSON.stringify({ userId: userDetails?._id }));
      formData.append("formValues", JSON.stringify(values));
      updatedImages.forEach((file) => {
        formData.append("files", file?.file);
      });
      API.post(`/user/makeHappyCustomer/${userDetails?._id}`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }).then((res) => {
        setSubmitLoading(true);
        if (res.status === 200) {
          setSubmitLoading(false);
          setHappyFormDialog(false);
          setHappyDialog(false);
          dispatch(
            setAlert({
              title: "Success",
              subtitle: "Customer marked as happy customer successfully",
              active: true,
              type: "success",
            })
          );
          setCount(count + 1);
        }
      });
    },
  });

  const updateFiles = (incommingFiles) => {
    setFiles(incommingFiles);

    const newUrls = incommingFiles?.map((file) =>
      URL.createObjectURL(file.file)
    );
    setFileUrls(newUrls);
    //even your own upload implementation
  };

  const removeFile = (id) => {
    const updatedFiles = files.filter((x) => x?.id !== id);
    const removedFileIndex = files.findIndex((file) => file?.id === id); //find the index of the removed file

    setFiles(updatedFiles);

    // Remove the corresponding URL
    setFileUrls((prevUrls) => {
      const newUrls = [...prevUrls];
      newUrls.splice(removedFileIndex, 1); // Remove the url at the same index
      return newUrls;
    });
  };

  return (
    <>
      {loading ? (
        <PreviewUserLoader />
      ) : (
        <motion.div
          id="printable-area"
          className="min-h-screen w-full flex flex-col relative px-2 py-2"
        >
          <motion.div className="flex no-print flex-row my-5 justify-between items-center w-full">
            <motion.div
              className="flex bg-primeColor flex-row px-5 py-1 rounded-full w-fit text-black items-center justify-center cursor-pointer hover:bg-black  hover:text-primeColor my-2"
              onClick={() => history.goBack()}
            >
              <FaArrowLeft />
              &nbsp; <p className="my-1">Back to Users</p>
            </motion.div>
            <motion.div className="flex flex-row justify-start gap-2">
              {(userDetails?.status === 0 || userDetails?.status === 2) && (
                <motion.div
                  className="bg-[green] text-white cursor-pointer w-fit px-2 py-2 rounded-full"
                  onClick={() => approveProfile()}
                >
                  Approve
                </motion.div>
              )}
              {(userDetails?.status === 0 || userDetails?.status === 1) && (
                <motion.div
                  className="bg-[red] text-white cursor-pointer w-fit px-2 py-2 rounded-full"
                  onClick={() => declineProfile()}
                >
                  Decline
                </motion.div>
              )}
              {(userDetails?.status === 1 || userDetails?.status === 2) && (
                <motion.div
                  className="bg-white text-black drop-shadow-xl cursor-pointer w-fit px-2 py-2 rounded-full"
                  onClick={() => pendingProfile()}
                >
                  Move To Pending
                </motion.div>
              )}
              {userDetails?.status === 6 && (
                <motion.div
                  className="bg-[green] text-white cursor-pointer w-fit px-2 py-2 rounded-full"
                  onClick={() => verifyProfile()}
                >
                  Verify Changes
                </motion.div>
              )}
              {userDetails.status === 1 && (
                <motion.div
                  className="bg-primeColor text-black cursor-pointer w-fit px-2 py-2 rounded-full"
                  onClick={() => setHappyDialog(true)}
                >
                  Happy Customer
                </motion.div>
              )}
            </motion.div>
          </motion.div>
          <div className="print:block hidden text-start font-bold text-xl mb-8">
            <div ref={printRef}>
              <PrintUser userDetails={userDetails} />
            </div>
          </div>
          <div className="print:block hidden fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-2/2 -rotate-45 text-[80px] font-bold text-primeColor/10 pointer-events-none select-none z-0 whitespace-nowrap">
            Royal Kavery
          </div>
          <motion.div className="flex flex-col no-print">
            {/* Basic Profile Details */}
            <motion.div className="flex flex-col md:flex-row justify-start gap-5">
              {/* User Uploaded Images */}
              <motion.div className="flex flex-col h-full gap-2 w-fit">
                <motion.div>
                  {userDetails?.previewUrls && userDetails?.previewUrls[0] ? (
                    <img
                      src={
                        userDetails?.previewUrls?.length > 0
                          ? userDetails?.previewUrls[0]?.imageUrl
                          : dummy
                      }
                      height={100}
                      width={100}
                      className="h-96 w-96 object-contain"
                      alt="Preview"
                    />
                  ) : (
                    <img
                      src={dummy}
                      height={100}
                      width={100}
                      className="h-96 w-96 object-contain"
                      alt="Preview"
                    />
                  )}
                </motion.div>
                <motion.div className="flex flex-row gap-1 w-96 overflow-x-scroll">
                  <PhotoProvider>
                    {userDetails &&
                      userDetails?.previewUrls?.map((photo) => {
                        return (
                          <PhotoView src={photo.imageUrl}>
                            <img
                              src={photo.imageUrl}
                              alt=""
                              height={100}
                              width={100}
                              className="object-cover cursor-pointer"
                            />
                          </PhotoView>
                        );
                      })}
                  </PhotoProvider>
                </motion.div>
              </motion.div>
              {/* User Details */}
              <motion.div className="flex flex-row justify-between w-full px-5">
                <motion.div className="flex flex-col h-full w-full gap-3">
                  <p
                    className={`text-sm font-bold ${
                      userDetails?.status === 6 &&
                      changes?.changesTo?.filter((x) => x.key === "firstName")
                        .length
                        ? "text-[red]"
                        : "text-primeColor"
                    }`}
                  >
                    {userDetails?.firstName}&nbsp;({userDetails?.surname}){" "}
                  </p>
                  <p className="text-sm font-bold text-primeColor">
                    {userDetails?.refId}
                  </p>
                  <p className="flex flex-row flex-wrap text-sm font-bold justify-start gap-2 items-center">
                    <img src={profession} alt="profession" />
                    <span
                      className={`${
                        userDetails?.status === 6 &&
                        changes?.changesTo?.filter(
                          (x) => x.key === "occupation"
                        ).length
                          ? "text-[red]"
                          : ""
                      }`}
                    >
                      {userDetails?.occupationDetail || userDetails?.occupation}
                    </span>
                    <span className="text-greyColor items-center font-bold text-sm">
                      |
                    </span>
                    {calculateAge(userDetails?.dateOfBirth)} {t("Years Old")}{" "}
                    <span
                      className={`text-greyColor items-center font-bold text-sm`}
                    >
                      |
                    </span>
                    <span
                      className={`${
                        changes?.changesTo?.filter(
                          (x) => x.key === "heightInFeet"
                        ).length > 0
                          ? "text-[red]"
                          : ""
                      }`}
                    >
                      {clearHeights(userDetails?.heightInFeet) || "-"}
                    </span>
                  </p>
                  <p className="flex flex-row text-sm  flex-wrap justify-start gap-2 items-center">
                    <img src={date} alt="income" height={30} width={30} />
                    {t("Date Of Birth")}
                    <span
                      className={`${
                        userDetails?.status === 6 &&
                        changes?.changesTo?.filter(
                          (x) => x.key === "dateOfBirth"
                        ).length
                          ? "text-[red]"
                          : "text-primeColor"
                      } items-center font-bold text-sm`}
                    >
                      {changes?.changesTo?.filter(
                        (x) => x.key === "dateOfBirth"
                      ).length
                        ? getChangedDateOfBirth(
                            changes?.changesTo?.filter(
                              (x) => x.key === "dateOfBirth"
                            )[0].value
                          )
                        : userDetails?.date +
                          "/" +
                          userDetails?.month +
                          "/" +
                          userDetails?.year}
                    </span>
                  </p>
                  <p className="flex flex-row text-sm  flex-wrap justify-start gap-2 items-center">
                    <img src={income} alt="income" height={30} width={30} />
                    {t("Income")}/
                    {userDetails?.salaryMode
                      ? t(`${userDetails?.salaryMode}`)
                      : "Month"}
                    <span
                      className={`${
                        userDetails?.status === 6 &&
                        changes?.changesTo?.filter((x) => x.key === "salary")
                          .length
                          ? "text-[red]"
                          : "text-primeColor"
                      } items-center font-bold text-sm`}
                    >
                      {userDetails?.salary}
                    </span>
                  </p>
                  <p className="flex flex-row text-sm  flex-wrap justify-start gap-2 items-center">
                    {" "}
                    <FaGraduationCap className="mx-1" size={20} />
                    {t("Qualification")}{" "}
                    <span
                      className={`${
                        userDetails?.status === 6 &&
                        changes?.changesTo?.filter(
                          (x) => x.key === "otherEducationalQualification"
                        ).length
                          ? "text-[red]"
                          : "text-primeColor"
                      } items-center font-bold text-sm`}
                    >
                      {userDetails?.otherEducationalQualification}
                    </span>
                  </p>
                  <p className="flex flex-row text-sm  flex-wrap justify-start gap-2 items-center">
                    <img
                      src={workLocation}
                      alt="building"
                      height={30}
                      width={30}
                    />
                    {t("Work Location")}
                    <span
                      className={`${
                        userDetails?.status === 6 &&
                        changes?.changesTo?.filter(
                          (x) => x.key === "occupationLocation"
                        ).length
                          ? "text-[red]"
                          : "text-primeColor"
                      } items-center font-bold text-sm`}
                    >
                      {userDetails?.occupationLocation || "--"}
                    </span>
                  </p>
                  <p className="flex flex-row text-sm  flex-wrap justify-start gap-2 items-center">
                    {" "}
                    <TbZodiacCancer className="mx-1" size={20} />
                    {t("Zodiac Sign")}{" "}
                    <span className="text-primeColor items-center font-bold text-sm">
                      {
                        zodiacSigns?.filter(
                          (x) =>
                            x?.value ===
                            userDetails?.additionalInformation?.zodiacSign
                        )[0]?.text
                      }
                    </span>
                  </p>
                  <p className="flex flex-row text-sm  flex-wrap justify-start gap-2 items-center">
                    {" "}
                    <img
                      src={stars}
                      alt="workLocatino"
                      height={30}
                      width={30}
                    />
                    {t("Star")}{" "}
                    <span className="text-primeColor items-center font-bold text-sm">
                      {userDetails?.additionalInformation?.star
                        ? allStars.filter(
                            (x) =>
                              x.value ===
                              userDetails?.additionalInformation?.star
                          )[0]?.text || "--"
                        : "-"}
                    </span>
                    <span
                      className={`font-bold ${
                        userDetails?.status === 6 &&
                        changes?.changesTo?.filter(
                          (x) => x.key === "additionalInformation.padham"
                        ).length
                          ? "text-[red]"
                          : "text-primeColor"
                      }`}
                    >
                      {userDetails?.additionalInformation?.padham}
                    </span>
                  </p>
                  <p className="flex flex-row text-sm  flex-wrap justify-start gap-2 items-center">
                    {" "}
                    <img
                      src={flawsIcon}
                      alt="workLocatino"
                      height={30}
                      width={30}
                    />
                    {t("Flaws")}{" "}
                    <span
                      className={`${
                        changes?.changesTo?.filter(
                          (x) => x.key === "additionalInformation.flaws"
                        ).length > 0
                          ? "text-[red]"
                          : "text-primeColor"
                      } items-center font-bold text-sm`}
                    >
                      {userDetails?.additionalInformation?.flaws?.length > 0
                        ? userDetails?.additionalInformation?.flaws?.map(
                            (c) => {
                              return getFlaws(c);
                            }
                          )
                        : "-"}
                    </span>
                  </p>
                  <p className="flex flex-row text-sm  flex-wrap justify-start gap-2 items-center">
                    {" "}
                    <RiPassValidFill className="mx-1" size={20} />
                    {t("Valid upto")}{" "}
                    <span className="text-orange-900 font-bold text-sm">
                      {validDetails?.planValidityDate}
                    </span>
                  </p>
                  {userDetails?.additionalInformation?.expectation && (
                    <motion.div className="flex flex-col gap-5">
                      <p className="text-sm font-bold text-primeColor">
                        {t("Expectations")}
                      </p>
                      <motion.div className="relative flex flex-row justify-start flex-wrap gap-2">
                        {/* {
                                            userDetails.additionalInformation.expectedOccupation.map((occu, i) => {
                                                return <motion.div className="w-fit px-2 py-1 rounded-full border border-primeColor bg-primeColor/20 text-primeColor font-bold">
                                                    {lang === 'en' ? occupation.filter((x) => x._id === occu)[0].occupation : occupation.filter((x) => x._id === occu)[0].tOccupation}
                                                </motion.div>
                                            })
                                        } */}
                        <motion.div
                          className={`${
                            changes?.changesTo?.filter(
                              (x) =>
                                x.key === "additionalInformation.expectation"
                            ).length > 0
                              ? "text-[red]"
                              : "text-primeColor"
                          } w-fit px-2 py-1 rounded-full border border-primeColor bg-primeColor/20 font-bold`}
                        >
                          {userDetails?.additionalInformation?.expectation}
                        </motion.div>
                      </motion.div>
                    </motion.div>
                  )}
                </motion.div>
                <motion.div className="no-print flex flex-col justify-center w-full h-full">
                  <motion.div
                    className="flex flex-row items-center text-sm"
                    onClick={() => handlePrint()}
                  >
                    <Button type={"primary"} injectClass={"w-fit"}>
                      {t("Print Profile")}
                    </Button>
                  </motion.div>
                </motion.div>
              </motion.div>
            </motion.div>
            <motion.div className="flex flex-row flex-wrap justify-start px-1 md:px-5 md:overflow-hidden relative w-fit gap-5 my-5">
              <motion.div className="flex flex-col gap-5 w-fit px-2 py-2 relative">
                <p className="text-xl font-bold text-primeColor">
                  {t("Family Information")}
                </p>
                <motion.div className="grid grid-cols-2 ">
                  <p>{t("Father name")}</p>
                  <p
                    className={`font-bold flex flex-row ${
                      userDetails?.status === 6 &&
                      changes?.changesTo?.filter(
                        (x) => x.key === "familyInformation.fatherFirstName"
                      ).length
                        ? "text-[red]"
                        : "text-primeColor"
                    }`}
                  >
                    {userDetails?.familyInformation?.fatherFirstName}&nbsp;
                    <span
                      className={`${
                        userDetails?.status === 6 &&
                        changes?.changesTo?.filter(
                          (x) => x.key === "familyInformation.fatherSurname"
                        )?.length
                          ? "text-[red]"
                          : "text-primeColor"
                      }`}
                    >
                      ({userDetails?.familyInformation?.fatherSurname})
                    </span>
                  </p>
                </motion.div>
                <motion.div className="grid grid-cols-2 ">
                  <p>{t("Father Occupation")}</p>
                  <p
                    className={`font-bold ${
                      userDetails?.status === 6 &&
                      changes?.changesTo?.filter(
                        (x) => x.key === "familyInformation.fatherOccupation"
                      ).length
                        ? "text-[red]"
                        : "text-primeColor"
                    }`}
                  >
                    {userDetails?.familyInformation?.fatherOccupation
                      ? userDetails?.familyInformation?.fatherOccupation
                      : "-"}
                  </p>
                </motion.div>
                <motion.div className="grid grid-cols-2 ">
                  <p>{t("Mother name")}</p>
                  <p
                    className={`font-bold flex flex-row ${
                      userDetails?.status === 6 &&
                      changes?.changesTo?.filter(
                        (x) => x.key === "familyInformation.motherFirstName"
                      ).length
                        ? "text-[red]"
                        : "text-primeColor"
                    }`}
                  >
                    {userDetails?.familyInformation?.motherFirstName}&nbsp;
                    <span
                      className={`${
                        userDetails?.status === 6 &&
                        changes?.changesTo?.filter(
                          (x) => x?.key === "familyInformation.motherSurname"
                        ).length
                          ? "text-[red]"
                          : "text-primeColor"
                      }`}
                    >
                      ({userDetails?.familyInformation?.motherSurname})
                    </span>
                  </p>
                </motion.div>
                <motion.div className="grid grid-cols-2 ">
                  <p>{t("Mother Occupation")}</p>
                  <p
                    className={`font-bold ${
                      userDetails?.status === 6 &&
                      changes?.changesTo?.filter(
                        (x) => x.key === "familyInformation.motherOccupation"
                      ).length
                        ? "text-[red]"
                        : "text-primeColor"
                    }`}
                  >
                    {userDetails?.familyInformation?.motherOccupation
                      ? userDetails?.familyInformation?.motherOccupation
                      : "-"}
                  </p>
                </motion.div>
                {/* <motion.div className="grid grid-cols-2 ">
                                <p>{t('Number of Siblings')}</p>
                                <p className={`font-bold text-primeColor`}>{userDetails.familyInformation.numberOfSiblings}</p>
                            </motion.div> */}
                <motion.div className="grid grid-cols-2 ">
                  <p>{t("Male Siblings")}</p>
                  <p
                    className={`font-bold ${
                      userDetails?.status === 6 &&
                      changes?.changesTo?.filter(
                        (x) =>
                          x.key === "familyInformation.numberOfMaleSiblings"
                      ).length
                        ? "text-[red]"
                        : "text-primeColor"
                    }`}
                  >
                    {userDetails?.familyInformation?.numberOfMaleSiblings}
                  </p>
                </motion.div>
                <motion.div className="grid grid-cols-2 ">
                  <p>{t("Female Siblings")}</p>
                  <p
                    className={`font-bold ${
                      userDetails?.status === 6 &&
                      changes?.changesTo?.filter(
                        (x) =>
                          x.key === "familyInformation.numberOfFemaleSiblings"
                      ).length
                        ? "text-[red]"
                        : "text-primeColor"
                    }`}
                  >
                    {userDetails?.familyInformation?.numberOfFemaleSiblings}
                  </p>
                </motion.div>
                <motion.div className="grid grid-cols-2 ">
                  <p>{t("Married Male Siblings")}</p>
                  <p
                    className={`font-bold ${
                      userDetails?.status === 6 &&
                      changes?.changesTo?.filter(
                        (x) => x.key === "familyInformation.marriedMaleSiblings"
                      ).length
                        ? "text-[red]"
                        : "text-primeColor"
                    }`}
                  >
                    {userDetails?.familyInformation?.marriedMaleSiblings}
                  </p>
                </motion.div>
                <motion.div className="grid grid-cols-2 ">
                  <p>{t("Married Female Siblings")}</p>
                  <p
                    className={`font-bold ${
                      userDetails?.status === 6 &&
                      changes?.changesTo?.filter(
                        (x) =>
                          x.key === "familyInformation.marriedFemaleSiblings"
                      ).length
                        ? "text-[red]"
                        : "text-primeColor"
                    }`}
                  >
                    {userDetails?.familyInformation?.marriedFemaleSiblings}
                  </p>
                </motion.div>
                <motion.div className="grid grid-cols-2 ">
                  <p>{t("Siblings Details")}</p>
                  <p
                    className={`font-bold ${
                      userDetails?.status === 6 &&
                      changes?.changesTo?.filter(
                        (x) => x.key === "familyInformation.siblingsDetails"
                      ).length
                        ? "text-[red]"
                        : "text-primeColor"
                    }`}
                  >
                    {userDetails?.familyInformation?.siblingsDetails}
                  </p>
                </motion.div>
              </motion.div>
              <div className="h-auto w-[1px] lg:block hidden  bg-primeColor"></div>
              <motion.div className="flex flex-col gap-5 w-fit px-2 py-2 relative">
                <p className="text-xl font-bold text-primeColor">
                  {t("Contact Information")}
                </p>
                <motion.div className="grid grid-cols-2 w-full">
                  <p>{t("Phone Number")}</p>
                  <p
                    className={`font-bold ${
                      userDetails?.status === 6 &&
                      changes?.changesTo?.filter(
                        (x) => x.key === "contactInformation.mobileNumber"
                      ).length
                        ? "text-[red]"
                        : "text-primeColor"
                    }`}
                  >
                    {userDetails?.contactInformation?.mobileNumber}
                  </p>
                </motion.div>
                <motion.div className="grid grid-cols-2 w-full">
                  <p>{t("Email Id")}</p>
                  <p
                    className={`font-bold ${
                      userDetails?.status === 6 &&
                      changes?.changesTo?.filter(
                        (x) => x.key === "contactInformation.email"
                      ).length
                        ? "text-[red]"
                        : "text-primeColor"
                    }`}
                  >
                    {userDetails?.contactInformation?.email || "-"}
                  </p>
                </motion.div>
                <motion.div className="grid grid-cols-2 w-full">
                  <p>{t("Present Address")}</p>
                  <p
                    className={`font-bold ${
                      userDetails?.status === 6 &&
                      changes?.changesTo?.filter(
                        (x) =>
                          x.key ===
                          "contactInformation.presentAddress.addressLine1"
                      ).length
                        ? "text-[red]"
                        : "text-primeColor"
                    }`}
                  >
                    {
                      userDetails?.contactInformation?.presentAddress
                        ?.addressLine1
                    }
                    ,
                  </p>
                  {userDetails.contactInformation.presentAddress
                    ?.addressLine2 && (
                    <>
                      <br />
                      <p
                        className={`font-bold ${
                          userDetails.status === 6 &&
                          changes?.changesTo?.filter(
                            (x) =>
                              x.key ===
                              "contactInformation.presentAddress.addressLine2"
                          ).length
                            ? "text-[red]"
                            : "text-primeColor"
                        }`}
                      >
                        {
                          userDetails?.contactInformation?.presentAddress
                            ?.addressLine2
                        }
                        ,
                      </p>
                    </>
                  )}
                  <br />
                  <p
                    className={`font-bold ${
                      userDetails.status === 6 &&
                      changes?.changesTo?.filter(
                        (x) =>
                          x.key === "contactInformation.presentAddress.city"
                      ).length
                        ? "text-[red]"
                        : "text-primeColor"
                    }`}
                  >
                    {userDetails?.contactInformation?.presentAddress?.city},
                  </p>
                  <br />
                  <p
                    className={`font-bold ${
                      userDetails.status === 6 &&
                      changes?.changesTo?.filter(
                        (x) =>
                          x.key === "contactInformation.presentAddress.district"
                      ).length
                        ? "text-[red]"
                        : "text-primeColor"
                    }`}
                  >
                    {userDetails?.contactInformation?.presentAddress?.district}{" "}
                    - {userDetails?.contactInformation?.presentAddress?.pinCode}
                  </p>
                  <br />
                  <p
                    className={`font-bold ${
                      userDetails.status === 6 &&
                      changes?.changesTo?.filter(
                        (x) =>
                          x.key === "contactInformation.presentAddress.state"
                      ).length
                        ? "text-[red]"
                        : "text-primeColor"
                    }`}
                  >
                    {userDetails?.contactInformation?.presentAddress?.state}
                  </p>
                </motion.div>
                <motion.div className="grid grid-cols-2 w-full">
                  <p>{t("Native Address")}</p>
                  <p
                    className={`font-bold ${
                      userDetails.status === 6 &&
                      changes?.changesTo?.filter(
                        (x) =>
                          x.key ===
                          "contactInformation.nativeAddress.addressLine1"
                      ).length
                        ? "text-[red]"
                        : "text-primeColor"
                    }`}
                  >
                    {
                      userDetails?.contactInformation?.nativeAddress
                        ?.addressLine1
                    }
                    ,
                  </p>
                  {userDetails?.contactInformation?.nativeAddress
                    ?.addressLine2 && (
                    <>
                      <br />
                      <p
                        className={`font-bold ${
                          userDetails.status === 6 &&
                          changes?.changesTo?.filter(
                            (x) =>
                              x.key ===
                              "contactInformation.nativeAddress.addressLine2"
                          ).length
                            ? "text-[red]"
                            : "text-primeColor"
                        }`}
                      >
                        {
                          userDetails?.contactInformation?.nativeAddress
                            ?.addressLine2
                        }
                        ,
                      </p>
                    </>
                  )}
                  <br />
                  <p
                    className={`font-bold ${
                      userDetails.status === 6 &&
                      changes?.changesTo?.filter(
                        (x) => x.key === "contactInformation.nativeAddress.city"
                      ).length
                        ? "text-[red]"
                        : "text-primeColor"
                    }`}
                  >
                    {userDetails?.contactInformation?.nativeAddress?.city},
                  </p>
                  <br />
                  <p
                    className={`font-bold ${
                      userDetails.status === 6 &&
                      changes?.changesTo?.filter(
                        (x) =>
                          x.key === "contactInformation.nativeAddress.district"
                      ).length
                        ? "text-[red]"
                        : "text-primeColor"
                    }`}
                  >
                    {userDetails?.contactInformation?.nativeAddress?.district} -{" "}
                    {userDetails?.contactInformation?.nativeAddress?.pinCode}
                  </p>
                  <br />
                  <p
                    className={`font-bold ${
                      userDetails.status === 6 &&
                      changes?.changesTo?.filter(
                        (x) =>
                          x.key === "contactInformation.nativeAddress.district"
                      ).length
                        ? "text-[red]"
                        : "text-primeColor"
                    }`}
                  >
                    {userDetails?.contactInformation?.nativeAddress?.state}
                  </p>
                </motion.div>
              </motion.div>
              <div className="h-auto w-[1px] lg:block hidden bg-primeColor"></div>
              <motion.div className="flex flex-col gap-5 w-fit px-2 py-2 relative">
                <p className="text-xl font-bold text-primeColor">
                  Expected Information
                </p>
                <motion.div className="grid w-96 grid-cols-2">
                  <p>{t("Income")}</p>
                  <p
                    className={`font-bold w-60 ${
                      userDetails?.status === 6 &&
                      changes?.changesTo?.filter(
                        (x) => x.key === "additionalInformation.expectedSalary"
                      ).length
                        ? "text-[red]"
                        : "text-primeColor"
                    }`}
                  >
                    {userDetails?.additionalInformation?.expectedSalary || "--"}
                  </p>
                </motion.div>
                <motion.div className="grid w-96 grid-cols-2">
                  <p>{t("Status")}</p>
                  <p
                    className={`font-bold w-60 ${
                      userDetails?.status === 6 &&
                      changes?.changesTo?.filter(
                        (x) => x.key === "additionalInformation.expectedStatus"
                      ).length
                        ? "text-[red]"
                        : "text-primeColor"
                    }`}
                  >
                    {userDetails?.additionalInformation?.expectedStatus
                      ?.length > 0
                      ? userDetails?.additionalInformation?.expectedStatus?.map(
                          (c, i) => {
                            return (
                              <>
                                {getStatus(c)}
                                {i !==
                                  userDetails?.additionalInformation
                                    ?.expectedStatus?.length -
                                    1 && ","}
                                &nbsp;
                              </>
                            );
                          }
                        )
                      : "--"}
                  </p>
                </motion.div>
                <motion.div className="grid w-96 grid-cols-2">
                  <p>{t("Zodiac Signs")}</p>
                  <p
                    className={`font-bold w-60 ${
                      userDetails?.status === 6 &&
                      changes?.changesTo?.filter(
                        (x) =>
                          x.key === "additionalInformation.expectedZodiacSigns"
                      ).length
                        ? "text-[red]"
                        : "text-primeColor"
                    }`}
                  >
                    {userDetails?.additionalInformation?.expectedZodiacSigns
                      ?.length > 0
                      ? userDetails?.additionalInformation?.expectedZodiacSigns?.map(
                          (c, i) => {
                            return (
                              <>
                                {getZodiac(c)}
                                {i !==
                                  userDetails?.additionalInformation
                                    ?.expectedZodiacSigns?.length -
                                    1 && ","}
                                &nbsp;
                              </>
                            );
                          }
                        )
                      : "--"}
                  </p>
                </motion.div>
                <motion.div className="grid w-96 grid-cols-2">
                  <p>{t("Stars")}</p>
                  <p
                    className={`font-bold w-60 ${
                      userDetails?.status === 6 &&
                      changes?.changesTo?.filter(
                        (x) => x.key === "additionalInformation.expectedStars"
                      ).length
                        ? "text-[red]"
                        : "text-primeColor"
                    }`}
                  >
                    {userDetails?.additionalInformation?.expectedStars?.length >
                    0
                      ? userDetails?.additionalInformation?.expectedStars?.map(
                          (c, i) => {
                            return (
                              <>
                                {getStars(c)}
                                {i !==
                                  userDetails?.additionalInformation
                                    ?.expectedStars?.length -
                                    1 && ","}
                                &nbsp;
                              </>
                            );
                          }
                        )
                      : "--"}
                  </p>
                </motion.div>
                <motion.div className="grid w-96 grid-cols-2">
                  <p>{t("Asset Information")}</p>
                  <p
                    className={`font-bold w-60 ${
                      userDetails?.status === 6 &&
                      changes?.changesTo?.filter(
                        (x) => x.key === "familyInformation.assetInfo"
                      ).length
                        ? "text-[red]"
                        : "text-primeColor"
                    }`}
                  >
                    {userDetails?.familyInformation?.assetInfo || "--"}
                  </p>
                </motion.div>
              </motion.div>
            </motion.div>
            <motion.div className="flex flex-col gap-5 w-fit px-2 py-2 relative">
              <p className="text-xl font-bold text-primeColor">
                Birth Information
              </p>
              <motion.div className="flex flex-row flex-wrap gap-5">
                <motion.div className="grid w-80 grid-cols-2">
                  <p>{t("Birth Time")}&nbsp; :</p>
                  <p
                    className={`font-bold ${
                      userDetails?.status === 6 &&
                      changes?.changesTo?.filter((x) => x.key === "birthTime")
                        .length
                        ? "text-[red]"
                        : "text-primeColor"
                    }`}
                  >
                    {formatTo12Hour(userDetails?.birthTime)}
                  </p>
                </motion.div>
                <motion.div className="grid w-80 grid-cols-2">
                  <p>{t("Birth Place")}&nbsp; :</p>
                  <p
                    className={`font-bold ${
                      userDetails?.status === 6 &&
                      changes?.changesTo?.filter((x) => x.key === "birthPlace")
                        .length
                        ? "text-[red]"
                        : "text-primeColor"
                    }`}
                  >
                    {userDetails?.birthPlace}
                  </p>
                </motion.div>
                <motion.div className="grid w-80 grid-cols-2">
                  <p>{t("Dhisai Iruppu")}&nbsp; :</p>
                  <p
                    className={`font-bold ${
                      userDetails?.status === 6 &&
                      changes?.changesTo?.filter(
                        (x) => x.key === "thisaiIruppu"
                      ).length
                        ? "text-[red]"
                        : "text-primeColor"
                    }`}
                  >
                    {getDhisas(userDetails?.thisaiIruppu) || "-"}
                  </p>
                </motion.div>
                <motion.div className="grid w-80 grid-cols-2">
                  <p>{t("Thisai iruppu date")}&nbsp; :</p>
                  <p
                    className={`font-bold ${
                      userDetails?.status === 6 &&
                      changes?.changesTo?.filter(
                        (x) => x.key === "thisaiIruppuDate"
                      ).length
                        ? "text-[red]"
                        : "text-primeColor"
                    }`}
                  >
                    {userDetails?.thisaiIruppuDate}
                  </p>
                </motion.div>
                <motion.div className="grid w-80 grid-cols-2">
                  <p>{t("Thisai iruppu month")}&nbsp; :</p>
                  <p
                    className={`font-bold ${
                      userDetails?.status === 6 &&
                      changes?.changesTo?.filter(
                        (x) => x.key === "thisaiIruppuMonth"
                      ).length
                        ? "text-[red]"
                        : "text-primeColor"
                    }`}
                  >
                    {userDetails?.thisaiIruppuMonth}
                  </p>
                </motion.div>
                <motion.div className="grid w-80 grid-cols-2">
                  <p>{t("Thisai iruppu year")}&nbsp; :</p>
                  <p
                    className={`font-bold ${
                      userDetails?.status === 6 &&
                      changes?.changesTo?.filter(
                        (x) => x.key === "thisaiIruppuYear"
                      ).length
                        ? "text-[red]"
                        : "text-primeColor"
                    }`}
                  >
                    {userDetails?.thisaiIruppuYear}
                  </p>
                </motion.div>
              </motion.div>
            </motion.div>
            {
              <motion.div className="h-full flex flex-row w-full justify-between py-2 px-2 gap-2 my-2">
                {/* <RasiKattam rasiValues={userDetails.rasiKattam.rasiPlanets} readOnly={true} /> */}
                <RasiKattam
                  kattamOuterInjectClass={`h-[400px] w-[400px]`}
                  kattamInnerInjectclass={"h-[100px] w-[100px]"}
                  readOnly={true}
                  rasiValues={userDetails?.rasiKattam?.rasiPlanets}
                />
                {/* <AmsaKattam amsaValues={userDetails.amsaKattam.amsaPlanets} readOnly={true} /> */}
                <AmsaKattam
                  kattamOuterInjectClass={`h-[400px] w-[400px]`}
                  kattamInnerInjectclass={"h-[100px] w-[100px]"}
                  readOnly={true}
                  amsaValues={userDetails?.amsaKattam?.amsaPlanets}
                />
              </motion.div>
            }
          </motion.div>
        </motion.div>
      )}
      <Dialog
        title="Confirm Update"
        injectClass="w-[550px]"
        showDialog={happyDialog}
        onClose={() => setHappyDialog(false)}
      >
        <motion.div className="flex flex-col relative">
          <p>Are you sure you want to change the customer to happy customer?</p>
          <motion.div className="flex flex-row justify-center px-2">
            <Button
              type="secondary"
              injectClass={"w-fit"}
              onClick={() => setHappyDialog(false)}
            >
              No
            </Button>
            <Button
              type="primary"
              injectClass={"w-fit"}
              onClick={() => makeHappyCustomer()}
            >
              Yes
            </Button>
          </motion.div>
        </motion.div>
      </Dialog>

      <Dialog
        title="Confirm Update"
        showDialog={happyFormDialog}
        onClose={() => setHappyFormDialog(false)}
      >
        <motion.div className="flex flex-col w-full relative">
          <motion.div className="grid grid-cols-2 gap-2">
            <FieldInput
              label="Groom Name"
              fieldProps={happyForm.getFieldProps("groomName")}
              fieldHelper={happyForm.getFieldHelpers("groomName")}
              fieldMeta={happyForm.getFieldMeta("groomName")}
              edit={true}
              dataLoaded={true}
            />
            <FieldInput
              label="Bride Name"
              fieldProps={happyForm.getFieldProps("brideName")}
              fieldHelper={happyForm.getFieldHelpers("brideName")}
              fieldMeta={happyForm.getFieldMeta("brideName")}
              edit={true}
              dataLoaded={true}
            />
            <FieldInput
              label="Wedding Date"
              type="date"
              fieldProps={happyForm.getFieldProps("weddingDate")}
              fieldHelper={happyForm.getFieldHelpers("weddingDate")}
              fieldMeta={happyForm.getFieldMeta("weddingDate")}
              edit={true}
              dataLoaded={true}
            />
            <FieldInput
              label="Engagement Date"
              type="date"
              fieldProps={happyForm.getFieldProps("engagementDate")}
              fieldHelper={happyForm.getFieldHelpers("engagementDate")}
              fieldMeta={happyForm.getFieldMeta("engagementDate")}
              edit={true}
              dataLoaded={true}
            />
            <FieldInput
              label="Story"
              type="textarea"
              fieldProps={happyForm.getFieldProps("story")}
              fieldHelper={happyForm.getFieldHelpers("story")}
              fieldMeta={happyForm.getFieldMeta("story")}
              edit={true}
              dataLoaded={true}
            />
            <Dropzone
              className="relative my-5"
              onChange={updateFiles}
              value={files}
              accept="image/*"
              maxFiles={1}
            >
              {files.map((file) => (
                <FileMosaic
                  preview={true}
                  key={file.id}
                  {...file}
                  onDelete={removeFile}
                  info
                />
              ))}
            </Dropzone>
          </motion.div>
          <motion.div className="flex flex-row w-full items-center justify-between px-2">
            <Button
              type="secondary"
              injectClass={"w-fit"}
              disabled={submitLoading}
              onClick={() => setHappyFormDialog(false)}
            >
              Cancel
            </Button>
            <Button
              type="primary"
              injectClass={"w-fit"}
              disabled={submitLoading}
              onClick={() => happyForm.submitForm()}
            >
              Submit
            </Button>
          </motion.div>
        </motion.div>
      </Dialog>
    </>
  );
};

export default PreviewUser;
